import { ErrorWrapper } from "./ErrorElements";

const Error = ({ children }) => {
    return (
        <ErrorWrapper>{ children }</ErrorWrapper>
    )
}

export default Error
